import LoaderSpinner from "../Loader/LoaderSpinner";

const baseButtonClass =
  "font-medium text-[17px] left-[18px] py-2 px-8 rounded-xl disabled:cursor-not-allowed disabled:opacity-60";

const OrderFormActionButtons = ({
  onBack,
  onSave,
  isSaving = false,
  backLabel = "Back",
  saveLabel = "Save & Continue",
  saveButtonClassName = "text-white bg-[#ff7e00]",
  backButtonClassName = "text-[#777] bg-white border border-opacity-50",
  wrapperClassName = "flex items-center md:justify-end gap-4 pt-4 flex-wrap",
}) => {
  return (
    <div className={wrapperClassName}>
      {onBack ? (
        <button
          type="button"
          onClick={onBack}
          disabled={isSaving}
          className={`${baseButtonClass} ${backButtonClassName}`}
        >
          {backLabel}
        </button>
      ) : null}
      <button
        type="button"
        onClick={onSave}
        disabled={isSaving}
        className={`${baseButtonClass} ${saveButtonClassName} flex items-center justify-center gap-2`}
      >
        {isSaving ? <LoaderSpinner className="my-1" /> : saveLabel}
      </button>
    </div>
  );
};

export default OrderFormActionButtons;
